export default "__VITE_ASSET__Cwnf1efL__"